import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { NuevosCambiosPage } from './nuevos-cambios.page';

const routes: Routes = [
  {
    path: '',
    component: NuevosCambiosPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [NuevosCambiosPage]
})
export class NuevosCambiosPageModule {}
